'use client';
import { HeadingDescription } from '@/components/atoms/HeadingDescription';
import { HeadingText } from '@/components/atoms/HeadingText';
import { useSplitAndHeap } from '@/hooks/useSplitAndHeap';

const ReplaceHeading = () => {
	const { ReplaceFootprint } = useSplitAndHeap('ReplaceFootprint');
	const { treatment } = ReplaceFootprint;

	return (
		<>
			<HeadingText tag="h2" className="relative z-10 text-balance">
				Replacing your HVAC has never been easier
			</HeadingText>
			<HeadingDescription className="!mb-0 h-15">
				{treatment === 'off' &&
					`One of our trusted local partners will be in touch to quickly help you
						find the right solution for your home.`}
			</HeadingDescription>
		</>
	);
};

export default ReplaceHeading;
